
export default class FieldProto {

    constructor(config) {

        this.config = config;

        this.label = config.label;
        this.description = config.description;
        this.isRequired = config.isRequired;
        this.type = config.type;
        this.params = config.params?config.params:{};

    }

    toJson() {

        return {
            label: this.label,
            description: this.description,
            isRequired: this.isRequired,
            type: this.type,
            params: this.params
        }

    }

    valueToString(value) {
        return value;
    }
}